import { PLATFORM } from 'aurelia-framework';
import { IRoute, IRouteSettings } from '@shared/interfaces/interfaces';

export class Routes {

  public unknownRoute: IRoute = {
    route: ['members/notfound'],
    name: 'notfound',
    settings: <IRouteSettings>
      {
        spa: 'members',
      },
    moduleId: PLATFORM.moduleName('../pages/notfound/notfound', 'members-async-notfound'),
    nav: false,
    title: 'Page not found',
  };

  public routeArray: IRoute[] = [
    <IRoute>
      {
        route: ['members/home'],
        name: 'home',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/home/home', 'members-async-home'),
        nav: false,
        title: 'Curious Members - Home',
    },
    <IRoute>
    {
      route: ['members/lounge'],
      name: 'lounge',
      settings: <IRouteSettings>
        {
          spa: 'members',
          authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
        },
      moduleId: PLATFORM.moduleName('../pages/lounge/lounge', 'members-async-lounge'),
      nav: false,
      title: 'The Curiosity Lounge',
    },
    <IRoute>
      {
        route: ['members/courses'],
        name: 'courses',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/courses/courses', 'members-async-courses'),
        nav: false,
        title: 'Curious Members - Courses',
      },
    // <IRoute>
    //  {
    //    route: ['members/mycourses'],
    //    name: 'mycourses',
    //    settings: <IRouteSettings>
    //      {
    //        spa: 'members',
    //        authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
    //      },
    //    moduleId: PLATFORM.moduleName('../pages/mycourses/mycourses', 'members-async-mycourses'),
    //    nav: false,
    //    title: 'Curious Members - My Courses',
    //  },
    <IRoute>
      {
        route: ['members/mycourses/:id/:courseurl/'],
        name: 'course',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/course/course', 'members-async-course'),
        nav: false,
        // title: 'Library',
      },
    <IRoute>
      {
        route: ['members/curiosity-boxes'],
        name: 'boxes',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/boxes/boxes', 'members-boxes'),
        nav: true,
        title: 'Curiosity Boxes',
      },
    <IRoute>
      {
        route: ['members/discount-deals'],
        name: 'deals',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/discount-deals/discount-deals', 'members-async-discount-deals'),
        nav: true,
        title: 'Discount Deals',
      },
    <IRoute>
      {
        route: ['members/member-stories'],
        name: 'stories',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/member-stories/member-stories', 'members-async-member-stories'),
        nav: true,
        title: 'Member Stories',
      },
    <IRoute>
      {
        route: ['members/search'],
        name: 'search',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/search/search', 'members-async-search'),
        nav: false,
        title: 'Curious Members - Search',
      },
    <IRoute>
      {
        route: ['members/resources'],
        name: 'resources',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/resources/resources', 'members-async-resources'),
        nav: false,
        title: 'Curious Members - Resources',
      },
    <IRoute>
      {
        route: ['members/library/:id/:groupurl/:resourceurl?'],
        name: 'library',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/library/library', 'members-async-library'),
        nav: false,
        // title: 'Library',
      },
    <IRoute>
      {
        route: ['members/login'],
        name: 'login',
        settings: <IRouteSettings>
          {
            spa: 'members',
          },
        moduleId: PLATFORM.moduleName('../pages/identity/login/login', 'members-async-login'),
        nav: false,
        title: 'Curious Members - Login',
      },
    <IRoute>
      {
        route: ['members/account/logout'],
        name: 'logout',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/identity/logout/logout', 'members-async-logout'),
        nav: false,
        title: 'Curious Members - Logout',
      },
    <IRoute>
      {
        route: ['members/forgot'],
        name: 'forgot',
        settings: <IRouteSettings>
          {
            spa: 'members',
          },
        moduleId: PLATFORM.moduleName('../pages/identity/forgot/forgot', 'members-async-forgot'),
        nav: false,
        title: 'Curious Members - Forgot Password',
      },
    <IRoute>
      {
        route: ['members/transfer-account'],
        name: 'transfer-account',
        settings: <IRouteSettings>
          {
            spa: 'members',
          },
        moduleId: PLATFORM.moduleName('../pages/identity/transfer-account/transfer-account', 'members-async-transfer-account'),
        nav: false,
        title: 'Curious Members - Transfer Account',
      },
    <IRoute>
      {
        route: ['members/account/transfer-subscription'],
        name: 'transfer-subscription',
        settings: <IRouteSettings>
          {
            spa: 'members',
          },
        moduleId: PLATFORM.moduleName(
        '../pages/identity/transfer-subscription/transfer-subscription', 'members-async-transfer-subscription'),
        nav: false,
        title: 'Curious Members - Transfer Subscription',
      },
    <IRoute>
      {
        route: ['members/set-password'],
        name: 'set-password',
        settings: <IRouteSettings>
          {
            spa: 'members',
          },
        moduleId: PLATFORM.moduleName('../pages/identity/set-password/set-password', 'members-async-set-password'),
        nav: false,
        title: 'Curious Members - Set Password',
      },
    <IRoute>
      {
        route: ['members/reset'],
        name: 'reset',
        settings: <IRouteSettings>
          {
            spa: 'members',
          },
        moduleId: PLATFORM.moduleName('../pages/identity/reset/reset', 'members-async-reset'),
        nav: false,
        title: 'Curious Members - Reset Password',
      },
    <IRoute>
      {
        route: ['members/change-email'],
        name: 'change-email',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/identity/change/change', 'members-async-change'),
        nav: false,
        title: 'Curious Members - Confirm change of email address',
      },
    <IRoute>
      {
        route: ['members/confirm'],
        name: 'confirm',
        settings: <IRouteSettings>
          {
            spa: 'members',
          },
        moduleId: PLATFORM.moduleName('../pages/identity/confirm/confirm', 'members-async-confirm'),
        nav: false,
        title: 'Curious Members - Confirm account',
      },
    <IRoute>
      {
        route: ['members/account/manage/:context?'],
        name: 'manage',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/identity/manage/manage', 'members-async-manage'),
        nav: false,
        title: 'Curious Members - Manage account',
      },
    <IRoute>
      {
        route: ['members/account/payment-method'],
        name: 'payment-method',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/identity/payment-method/payment-method', 'members-async-payment-method'),
        nav: false,
        title: 'Curious Members - Update Payment Method',
      },
    <IRoute>
      {
        route: ['members/account/resume-subscription'],
        name: 'resume-subscription',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/identity/resume-subscription/resume-subscription', 'members-async-resume-subscription'),
        nav: false,
        title: 'Curious Members - Resume Subscription',
      },
    <IRoute>
      {
        route: ['members/account/activate-subscription'],
        name: 'activate-subscription',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/identity/activate-subscription/activate-subscription', 'members-async-activate-subscription'),
        nav: false,
        title: 'Curious Members - Activate Subscription',
      },
    <IRoute>
      {
        route: ['members/account/upgrade-subscription'],
        name: 'upgrade-subscription',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/identity/upgrade-subscription/upgrade-subscription', 'members-async-upgrade-subscription'),
        nav: false,
        title: 'Curious Members - Upgrade Subscription',
      },
    <IRoute>
      {
        route: ['members/account/products-payments'],
        name: 'products-payments',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/identity/products-payments/products-payments', 'members-async-products-payments'),
        nav: false,
        title: 'Curious Members - Products & Payments',
      },
    <IRoute>
      {
        route: ['members/contact'],
        name: 'contact',
        settings: <IRouteSettings>
          {
            spa: 'members',
            authorize: ['Member', 'Administrator', 'SuperAdmin', 'Mentor'],
          },
        moduleId: PLATFORM.moduleName('../pages/contact/contact', 'members-async-contact'),
        nav: false,
        title: 'Curious Members - Contact',
      },
  ];
}
